import { useParams } from "react-router";
import { DaAccountCreated } from "../../components/DaAccountCreated/DaAccountCreated";

function DaAccountCreatedPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaAccountCreated /> : null}
    </div>
  );
}

export default DaAccountCreatedPage;
